export default {
    READ: 0,
    ADMIN: 1,
    OWNER: 2,
    SUPPORT: 3,
}